import { EuiSpacer } from '@elastic/eui';
import MenuCards from 'components/Web_User_Interface/720p_Series/Video_Menu_Bar/MenuCards';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  MenuCards,
  BreadCrumbs,
  SEOHelmet,
  React
};